<div
    *ngIf="!inGlobalFilter; else globalFilterTemplate"
    fxLayout="row"
    fxFlex.lt-sm="0 0 80%"
    fxFlex="0 0 350px"
    class="app-search-table-wrapper"
    fxLayoutAlign="start center"
>
    <mat-form-field fxFlex="1 1 100%" class="search-box">
        <input
            fxFlex="0 0 100%"
            matInput
            #search
            placeholder="Filter by name..."
            i18n-placeholder="@@filterByName"
            [formControl]="control"
            data-testid="table-search-input"
        />
        <button matSuffix mat-icon-button *ngIf="!search.value.length">
            <mat-icon class="search-icon">search</mat-icon>
        </button>
        <button mat-icon-button matSuffix *ngIf="search.value.length" (click)="clear()">
            <mat-icon>clear</mat-icon>
        </button>
    </mat-form-field>
</div>
<!-- <div
    *ngIf="inGlobalFilter"
    fxLayout="row"
    fxFlex.lt-sm="0 0 80%"
    fxFlex="0 0 100px"
    class="app-search-table-wrapper"
    fxLayoutAlign="start center"
> -->
<!-- <mat-form-field [floatLabel]="never" fxFlex="1 1 100%" class="search-box">

        <input
            fxFlex="0 0 100%"
            matInput
            #search
            placeholder="Filter by name..."
            i18n-placeholder="@@filterByName"
            [formControl]="control"
        />
        <button matSuffix mat-icon-button *ngIf="!search.value.length">
            <mat-icon class="search-icon">search</mat-icon>
        </button>
        <button mat-icon-button matSuffix *ngIf="search.value.length" (click)="clear()">
            <mat-icon>clear</mat-icon>
        </button>
    </mat-form-field> -->
<!-- </div> -->

<ng-template #globalFilterTemplate>
    <mat-form-field class="global-search-title search-box" appearance="fill">
        <mat-label i18n="@@search">Search</mat-label>
        <input
            matInput
            #search
            [placeholder]="placeHolder"
            [formControl]="control"
            data-testid="table-search-input"
            (keyup.enter)="
                search.value?.length &&
                    search.value.length >= this.minQueryCharLength &&
                    filter.isMultiple &&
                    sendSearchQuery(search.value)
            "
        />
        <button
            mat-icon-button
            matSuffix
            *ngIf="search.value?.length && search.value.length >= this.minQueryCharLength && filter.isMultiple"
            (click)="sendSearchQuery(search.value)"
        >
            <mat-icon>add_circle_outline</mat-icon>
        </button>
    </mat-form-field>
</ng-template>

<ng-template #activeFilterTemplate let-filter="filter">
    <mat-icon>{{ filter.icon }}</mat-icon>
    <div
        [ngClass]="{ 'single-item-query-filter-search-item': filter.items?.length === 1 }"
        class="query-filter-search-item"
        *ngFor="let item of filter.items"
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="2px"
    >
        <span>{{ item }}</span>
        <mat-icon *ngIf="filter.items?.length > 1" (click)="removeItem(item)">do_not_disturb_on</mat-icon>
    </div>
</ng-template>
<ng-template #activeFilterTemplateMultiple let-filter="filter" let-joinTemplate="joinTemplate">
    <div
        class="multiple-item-query-filter-search-item"
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="2px"
        *ngFor="let item of filter.items; let index = index"
    >
        <ng-container
            *ngIf="joinTemplate && index !== 0"
            [ngTemplateOutlet]="joinTemplate"
            [ngTemplateOutletContext]="{ filter: filter }"
        ></ng-container>
        <mat-chip
            [selectable]="false"
            [removable]="true"
            (removed)="removeItem(item)"
            [ngStyle]="{ background: filter.color.bg, color: filter.color.fg }"
            class="{{ filter.filterResultsChipStyleClass }} filter-chip-item"
            [ngClass]="filter?.items?.length ? 'value' + filter.items[0] : ''"
        >
            <mat-icon>{{ filter.icon }}</mat-icon>
            <div
                [ngClass]="{ 'single-item-query-filter-search-item': filter.items?.length === 1 }"
                class="query-filter-search-item"
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="2px"
            >
                <span>{{ item }}</span>
                <mat-icon (click)="removeItem(item)">do_not_disturb_on</mat-icon>
            </div>
        </mat-chip>
    </div>
</ng-template>
